define('ordersUnpaidFiltersView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'ordersListFiltersView',
  'ordersUnpaidFiltersEditView',
  'filtersBannerView',
  'ordersController'
], function(
    App,
    Module,
    Backbone,
    _,
    Settings,
    OrdersFiltersView,
    EditView,
    FiltersBannerView,
    Controller
) {
  'use strict';

  Module.exports = OrdersFiltersView.extend({
    editViewClass: EditView,

    initialize: function() {
      Controller.filtersView = this;
      this.tableView = this.options.tableView;

      var savedFilters = Settings.get('unpaidOrdersFilters', true);
      if(savedFilters) {
        this.model = new Backbone.Model(JSON.parse(savedFilters));
      } else {
        this.model = new Backbone.Model({
          purchaseOrderId: '',
          status: '',
          endUserId: '',
          companyName: '',
          productBaseCode: '',
          productSupplierCode: '',
          productOwner: '',
          quantityFrom: '',
          quantityTo: '',
          priceFrom: '',
          priceTo: '',
          minOrderPrice: '',
          dateFrom: '',
          dateTo: '',
          actionRequiredUkr: '',
          actionRequiredInternal: '',
          payedByCustomer: 'false',
          showOnlyMine: '',
          notAssigned: '',
          userPidSecIds: '',
          toInvoice: '',
          cardColor: '',
          webshop: '',
          validated: '',
          vip: '',
          supplierNumber: '',
          clientNumber: ''
        });
      }

      // The whole screen is scoped to unpaid orders
      this.model.set('payedByCustomer', 'false');
      Settings.set('unpaidOrdersFilters', JSON.stringify(this.model.attributes), true);
      this.tableView.filters = this.model;

      FiltersBannerView.prototype.initialize.apply(this, arguments);
    },

    setCollection: function() {
      OrdersFiltersView.prototype.setCollection.apply(this, arguments);

      // payedByCustomer = false is implicit on this screen, don't show it as a removable filter
      var payedChip = this.collection.findWhere({id: 'payedByCustomer'});
      if(payedChip)
        this.collection.remove(payedChip);
    },

    fetch: function(model) {
      model.set('payedByCustomer', 'false');

      var needFetch = false;
      _.each(model.attributes, function (value, key) {
        if(this.model.get(key) !== value)
          needFetch = true;
      }, this);

      FiltersBannerView.prototype.fetch.apply(this, arguments);

      Settings.set('unpaidOrdersFilters', JSON.stringify(this.model.attributes), true);

      if(needFetch) {
        this.tableView.footerView.setCurrentPage(1);
        this.tableView.bodyView.fetch();
        this.tableView.footerView.fetch();
      }
    }
  });
});

